// extracted by mini-css-extract-plugin
export default {"inputWrapper":"SearchInput_inputWrapper__l3OfP","input":"SearchInput_input__luW2Q"};